import(/* webpackMode: "eager" */ "C:\\Websites\\pawtree-FE\\PawtreeFrontend\\node_modules\\next\\dist\\client\\image-component.js");
;
import(/* webpackMode: "eager" */ "C:\\Websites\\pawtree-FE\\PawtreeFrontend\\node_modules\\next\\dist\\client\\link.js");
;
import(/* webpackMode: "eager" */ "C:\\Websites\\pawtree-FE\\PawtreeFrontend\\src\\assets\\icons\\Featured icon.svg");
;
import(/* webpackMode: "eager" */ "C:\\Websites\\pawtree-FE\\PawtreeFrontend\\src\\assets\\icons\\table-dead-state-icon.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Websites\\pawtree-FE\\PawtreeFrontend\\src\\components\\HtmlRender\\index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Websites\\pawtree-FE\\PawtreeFrontend\\src\\components\\V2\\Container\\index.tsx");
